<template>
  <main-template>
    <v-row>
      <v-col>
        <span id="apoio-title" class="text-h4">Profissionais de Apoio</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <div id="apoio-actions" class="d-flex mb-2 justify-space-between">
          <v-btn
            id="create-apoio-btn"
            color="success"
            @click="criarProfissionaldeApoio"
            class="mr-2"
            >Criar Profissional</v-btn
          >
          <v-text-field
            id="search-apoio-input"
            v-model="search"
            class="ml-2 search-input"
            append-icon="mdi-magnify"
            label="Pesquisar..."
            solo
            dense
            single-line
            hide-details
          />
        </div>
      </v-col>
      <v-col class="pt-0">
        <v-data-table
          id="apoio-data-table"
          :headers="table.headers"
          :items="profissionaisDeApoioList"
          :loading="carregandoProfissionalDeApoio"
          :items-per-page="10"
          :custom-filter="dataTableFilter"
          :search="search"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody
              id="apoio-table-body"
              name="scroll-x-transition"
              is="transition-group"
              duration="150"
            >
              <tr
                v-for="(profissionalDeApoio, index) in items"
                :key="profissionalDeApoio.id"
                :id="`apoio-row-${index}`"
                color="primary"
                :class="profissionalDeApoio.estaDeletado ? ['deleted'] : []"
              >
                <td :id="`apoio-id-${index}`">{{ profissionalDeApoio.id }}</td>
                <td :id="`apoio-nome-${index}`">{{ profissionalDeApoio.nome }}</td>
                <td :id="`apoio-email-${index}`">{{ profissionalDeApoio.email }}</td>
                <td :id="`apoio-role-${index}`">
                  <e-user-role :value="profissionalDeApoio.user" />
                </td>
                <td v-if="!profissionalDeApoio.estaDeletado" :id="`apoio-actions-${index}`">
                  <template>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :id="`edit-apoio-btn-${index}`"
                          x-small
                          class="ml-1"
                          color="blue-grey lighten-3"
                          v-bind="attrs"
                          v-on="on"
                          @click="() => editarProfissionalDeApoio(profissionalDeApoio)"
                        >
                          <v-icon small>fa fa-edit </v-icon>
                        </v-btn>
                      </template>
                      <span>Editar Profissional de Apoio</span>
                    </v-tooltip>
                    <v-tooltip color="error" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :id="`delete-apoio-btn-${index}`"
                          x-small
                          class="ml-1"
                          color="error"
                          v-bind="attrs"
                          v-on="on"
                          @click="() => deletarProfissionalDeApoio(profissionalDeApoio)"
                        >
                          <v-icon small>fa fa-trash </v-icon>
                        </v-btn>
                      </template>
                      <span>Apagar Profissional de Apoio</span>
                    </v-tooltip>
                  </template>
                </td>
                <td v-if="profissionalDeApoio.estaDeletado" :id="`apoio-recover-${index}`">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :id="`recover-apoio-btn-${index}`"
                        x-small
                        class="ml-1"
                        color="info"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => recuperarProfissionalDeApoio(profissionalDeApoio)"
                      >
                        <v-icon small>fa fa-sync </v-icon>
                      </v-btn>
                    </template>
                    <span>Recuperar Profissional de Apoio</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <e-paginate
          id="apoio-pagination"
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="page"
          @changeActionResponse="listarProfissionaisDeApoio"
          :search="search"
        ></e-paginate>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
import { dataTableFilter } from "@/plugins/searchQuery";
import ProfissionalDeApoio from "../../Models/ProfissionalDeApoio";

export default {
  computed: {},
  data() {
    return {
      carregandoProfissionalDeApoio: false,
      profissionaisDeApoioList: [],
      page: 0,
      paginate: {
        current_page: 0,
        last_page: 0,
      },
      dataTableFilter,
      search: "",
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Nome", value: "nome" },
          { text: "Email", value: "email" },
          { text: "Perfil", value: "role_id" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
    };
  },
  async mounted() {
    await this.listarProfissionaisDeApoio();
  },
  watch: {
    async search(val) {
      if (val.length > 3) {
        await this.listarProfissionaisDeApoio(0, val);
      }
      if (!val) {
        await this.listarProfissionaisDeApoio(0);
      }
    },
    carregandoProfissionalDeApoio(value) {
      if (value && this.profissionaisDeApoioList.length === 0) {
        this.$loaderService.open("Carregando dados");
      } else {
        this.$loaderService.close();
      }
    },
  },
  methods: {
    async listarProfissionaisDeApoio(pageNumber, query) {
      this.carregandoProfissionalDeApoio = true;
      this.$loaderService.open("Carregando Profissionais de Apoio");

      const response = await this.$services.profissionaisDeApoioService.syncAllPaginate(
        pageNumber,
        query
      );

      this.profissionaisDeApoioList = response.data.data.map(
        (profissionalDeApoio) => new ProfissionalDeApoio(profissionalDeApoio)
      );
      this.paginate = response.data;
      this.carregandoProfissionalDeApoio = false;
      this.$loaderService.close();
    },
    criarProfissionaldeApoio() {
      this.$router.push({ name: "profissionaisDeApoio.create" });
    },
    editarProfissionalDeApoio(profissionalDeApoio) {
      this.$router.push({
        name: "profissionaisDeApoio.edit",
        params: { profissionalDeApoio_id: profissionalDeApoio.id },
      });
    },
    async deletarProfissionalDeApoio(profissionalDeApoio) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar este(a) profissional de apoio?",
        confirmationCode: profissionalDeApoio.id,
        confirmationMessage: `Por favor, digite <strong>${profissionalDeApoio.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando o(a) Profissional de Apoio");
              try {
                await this.$services.profissionaisDeApoioService.deletarProfissionalDeApoio(
                  profissionalDeApoio
                );
                this.$toast.success("Profissional de Apoio deletado(a) com sucesso");
                await this.listarProfissionaisDeApoio();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
    recuperarProfissionalDeApoio(profissionalDeApoio) {
      this.$modals.warn({
        title: "Atenção!",
        message: "Tem certeza que deseja recuperar este(a) profissional de apoio?",
        confirmationCode: profissionalDeApoio.id,
        confirmationMessage: `Por favor, digite <strong>${profissionalDeApoio.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Recuperando o(a) Profissional de Apoio");
              try {
                await this.$services.profissionaisDeApoioService.recuperarProfissionalDeApoio(
                  profissionalDeApoio
                );
                this.$toast.success("Profissional de Apoio recuperado(a) com sucesso");
                this.listarProfissionaisDeApoio(0, this.search);
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
  },
};
</script>

<style></style>
